import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const initMain = () => {
  const sloganLeft = document.querySelector('.slogan-wrap .box-left');
  const sloganRight = document.querySelector('.slogan-wrap .box-right');
  const bgBar1 = document.querySelector('.bar-1');
  const bgBar2 = document.querySelector('.bar-2');

  const body = document.body;
  const site = document.querySelector('.site');

  // gsap.to(sloganLeft, {duration: .25, autoAlpha: 1});
  ScrollTrigger.matchMedia({
    "(min-width: 991px)": function() {
      gsap.to(sloganLeft, {
        yPercent: -50,
        ease: 'none',
        scrollTrigger: {
          trigger: site,
          scrub: 1,
        }
      });
      gsap.to(sloganRight, {
        yPercent: 50,
        ease: 'none',
        scrollTrigger: {
          trigger: site,
          scrub: 1,
        }
      });
    }
  })
  // gsap.to(sloganLeft, {
  //   yPercent: -50,
  //   ease: 'none',
  //   scrollTrigger: {
  //     trigger: site,
  //     scrub: 1,
  //   }
  // });

  gsap.to(bgBar1, {
    yPercent: 80,
    ease: 'none',
    scrollTrigger: {
      trigger: site,
      scrub: 1,
    }
  });
  gsap.to(bgBar2, {
    yPercent: -100,
    ease: 'none',
    scrollTrigger: {
      trigger: site,
      scrub: 1,
    }
  })

  // const body = document.body;
  // const sloganLeftTl = gsap.timeline();

  // sloganLeftTl
  //   .to(sloganLeft, { yPercent: -10});
  // ScrollTrigger.create({
  //   trigger: body,
  //   start: 'top bottom',
  //   end: 'top bottom',
  //   animation: sloganLeftTl,
  //   markers: true,
  //   scrub: true,
  // })
}
export default initMain;